import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import { MapPin, User, ExternalLink, Briefcase } from "lucide-react";

export default function PublicProfile() {
  const { userId } = useParams();
  const [profile, setProfile] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/profile/${userId}`).then((r) => setProfile(r.data)).catch(() => setNotFound(true));
  }, [userId]);

  if (notFound) return (
    <div className="max-w-2xl mx-auto p-12 text-center">
      <div className="font-display text-4xl uppercase">Profile private or not found</div>
    </div>
  );
  if (!profile) return <div className="max-w-4xl mx-auto p-12 text-zinc-500 font-mono-alt uppercase text-sm">Loading…</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="border border-zinc-800 bg-zinc-950/50 p-8">
        <div className="flex items-center gap-6">
          {profile.picture ? (
            <img src={profile.picture} alt="" className="w-20 h-20 border border-zinc-800" />
          ) : (
            <div className="w-20 h-20 border border-zinc-800 flex items-center justify-center"><User size={32} className="text-zinc-500" /></div>
          )}
          <div>
            <div className="text-xs font-mono-alt uppercase text-yellow-500 tracking-widest mb-1">Apprentice</div>
            <h1 className="font-display text-4xl md:text-5xl uppercase leading-none">{profile.name || "Anonymous"}</h1>
            {profile.location && <div className="text-zinc-400 text-sm mt-2 flex items-center gap-1"><MapPin size={14} className="text-yellow-500" />{profile.location}</div>}
          </div>
        </div>
        {profile.headline && (
          <div className="mt-6 text-xl text-white">{profile.headline}</div>
        )}
        {profile.experience_years > 0 && (
          <div className="mt-3 flex items-center gap-1 text-sm text-zinc-400">
            <Briefcase size={14} className="text-yellow-500" />{profile.experience_years} year{profile.experience_years !== 1 ? "s" : ""} experience
          </div>
        )}
      </div>

      {profile.bio && (
        <div className="mt-8">
          <h2 className="font-display text-2xl uppercase text-yellow-500 mb-3">About</h2>
          <p className="text-zinc-300 leading-relaxed">{profile.bio}</p>
        </div>
      )}

      {(profile.skills || []).length > 0 && (
        <div className="mt-8">
          <h2 className="font-display text-2xl uppercase text-yellow-500 mb-3">Skills</h2>
          <div className="flex flex-wrap gap-2">
            {profile.skills.map((s) => (<span key={s} className="text-xs font-mono-alt uppercase tracking-widest border border-zinc-800 px-3 py-1 text-zinc-200">{s}</span>))}
          </div>
        </div>
      )}

      {profile.links && Object.keys(profile.links).length > 0 && (
        <div className="mt-8">
          <h2 className="font-display text-2xl uppercase text-yellow-500 mb-3">Links</h2>
          <div className="flex flex-col gap-2">
            {Object.entries(profile.links).map(([k, v]) => v && (
              <a key={k} href={v} target="_blank" rel="noreferrer" className="text-zinc-300 hover:text-yellow-500 text-sm flex items-center gap-1">
                <ExternalLink size={12} /> {v}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
